import { render, staticRenderFns } from "./contentCourseCreate.vue?vue&type=template&id=559ad280&"
import script from "./contentCourseCreate.vue?vue&type=script&lang=js&"
export * from "./contentCourseCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports